import { Link } from "react-router-dom";
import '../standard16/css_16/userCertificate.css';
import { properties } from '../properties.js';
import { checkFileType} from '../functions.js';

import React, { useState, useEffect } from 'react';



const CertificateDisplay = ({ item, index, account, mapping, certificadoId, certificadoName }) => {
  
    
  const [imageUri, setImageUri] = useState(''); // Estado para almacenar la URL de la imagen

  useEffect(() => {
    const fetchImageUri = async () => {
      const uri = await checkFileType(item.tokenUri); // Lógica asíncrona
      setImageUri(uri); // Guarda la URL de la imagen en el estado
    };

    fetchImageUri(); // Ejecuta la función cuando el componente se monta
  }, [item.tokenUri]); // Vuelve a ejecutarse si item.tokenUri cambia
  
 
  if(typeof(mail) == properties.noMailValue){
      return (
        <div className="card_item_16" key={item.id}>
  
          <Link className="models_16" to={`/${mapping}/standard8/certificateDisplay?ercId=${item.id}&itemModel=${item.modelo}&descripcion=${item.descripcion}&campoNumerico=${item.campoNumerico}&idProducto=${item.idProducto}&userInfo=${item.userInfo}&campoFecha=${item.campoFecha}&uri=${item.tokenUri}&account=${account}&certificadoId=${certificadoId}&certificadoName=${certificadoName}`} state={item}>
  
            <img className="card_img_16" src={imageUri} alt="Item"/>
            <p className="card_model_16"> {item.modelo} </p>
  
          </Link>
        </div>
      );
  
    }
  }
  
  export default CertificateDisplay;